import cssCustomProperties from '~css-custom-properties-for-js';

export default function cssCustomPropertiesPlugin({ config }, inject) {
  const vars = cssCustomProperties || config.cssCustomProperties || {};
  inject('cp', Object.freeze(vars));
}
